<template>
  <div>
    <v-breadcrumbs :items="breadcrumbItems"></v-breadcrumbs>
    <v-card flat>
      <v-card-title
        class="display-1 d-block text-truncate text-center"
        :title="customer.name"
        >{{ customer.name }}</v-card-title
      >
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col class="text-center">
            <span class="headline">${{ specSales }}</span>
            <div class="caption text-uppercase">Specified</div>
          </v-col>
          <v-col class="text-center">
            <span class="headline">{{ samples }}</span>
            <div class="caption text-uppercase">Samples</div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <library></library>
  </div>
</template>

<script>
import CustomerData from "../customerData";
import CustomerBinders from "../customerBinders";
import Library from "../components/Library";

import { createNamespacedHelpers } from "vuex";
const { mapState, mapMutations } = createNamespacedHelpers("customer/");

export default {
  name: "customer",
  components: {
    Library
  },
  computed: {
    ...mapState(["customer", "library"]),
    fakeCustomers() {
      return CustomerData;
    },
    fakeBinders() {
      return CustomerBinders;
    },
    specSales() {
      return new Intl.NumberFormat().format(this.customer.specSales);
    },
    samples() {
      return new Intl.NumberFormat().format(this.customer.samples);
    },
    customerName() {
      return this.customer.name;
    },
    breadcrumbItems() {
      return [
        {
          text: "Customers",
          disabled: false,
          href: "/customers"
        },
        {
          text: this.customerName,
          disabled: false,
          href: ""
        }
      ];
    }
  },
  methods: {
    ...mapMutations(["setCustomer", "setLibrary"]),
    loadCustomer() {
      const customer = this.fakeCustomers.filter(
        customer => customer.id === parseInt(this.$route.params.customerId)
      )[0];
      let library = this.fakeBinders;
      library = library.map(binder => {
        binder.placed = Math.floor(Math.random() * 91) + 10;
        return binder;
      });

      this.setCustomer(customer);
      this.setLibrary(library);
    }
  },
  created() {
    this.loadCustomer();
  }
};
</script>

<style scoped></style>
